import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import success from '../../assets/images/backoffice/kyc6.png';
import { BACKOFFICE_NAME } from '../../helpers/helperFunctions';
import { ORDERS } from '../../routes/routes';
import { H3 } from '../../styles/FontStyles';
import { Button, Flexed } from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';

export const PaymentSuccess2 = () => {
  const history = useHistory();
  const { t } = useTranslation('packages');

  return (
    <>
      <Flexed justifyCenter>
        <img src={success} alt='success' />
      </Flexed>
      <H3 center mb='5' color={color.colors.neutral900}>
        {BACKOFFICE_NAME} {t('license_successfully_purchased_and_activated')}
      </H3>

      <Button mt='40' onClick={() => history.push(ORDERS)}>
        {t('close')}
      </Button>
    </>
  );
};
